import { render, staticRenderFns } from "./ModalDialog.vue?vue&type=template&id=45edb81e&scoped=true&"
import script from "./ModalDialog.vue?vue&type=script&lang=js&"
export * from "./ModalDialog.vue?vue&type=script&lang=js&"
import style0 from "./ModalDialog.vue?vue&type=style&index=0&id=45edb81e&lang=scss&"
import style1 from "./ModalDialog.vue?vue&type=style&index=1&id=45edb81e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45edb81e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45edb81e')) {
      api.createRecord('45edb81e', component.options)
    } else {
      api.reload('45edb81e', component.options)
    }
    module.hot.accept("./ModalDialog.vue?vue&type=template&id=45edb81e&scoped=true&", function () {
      api.rerender('45edb81e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/ModalDialog.vue"
export default component.exports